import { Button, Loading, Modal } from '@descomplica/foundation-ui-components';
import { observer, useViewModel } from '@descomplica/microfrontend-react';
import React from 'react';
import { useState } from 'react';
import styled from 'styled-components';

import { useOutsideClick } from '@/shared/application/utils';
import { EFileExtension, exportObjectSheet } from '@/shared/application/utils/sheets';

import { CreateInvitationViewModel } from '../CreateInvitation.vm';

const MyModal = styled(Modal)`
  position: fixed;

  div {
    height: auto;
    width: auto;
    max-width: 600px;
  }
`;

const Container = styled.div`
  display: flex;
  padding: 1rem 2rem;
  flex-direction: column;
  align-items: center;
  height: auto;
  min-width: 300px;
`;

const Title = styled.h2`
  font-weight: 900;
  font-size: 24px;
  line-height: 120%;
  text-align: center;
  letter-spacing: -1.2px;
  color: #111111;
  padding: 0;
  margin: 0;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  margin-top: 28px;
`;

const Wrapper = styled.div`
  display: inline-block;
  box-sizing: border-box;
  position: relative;
`;

const Content = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  width: fit-content;
  cursor: pointer;
`;

const Dropdown = styled.ul<{ align?: string }>`
  background-color: #19f88f;
  width: 120px;
  padding: 0;
  position: absolute;
  transition: all 0.25s ease-out;
  display: none;
  transform-origin: 100% 0;
  top: 40px;
  left: 15px;
  ${(props) => props.align || 'left'}: 0;
  margin: 0;
  border-radius: 0 0 10px 10px;

  &.active {
    display: flex;
    flex-direction: row;
  }

  li:first-child {
    border-radius: 0 0 0px 10px;
  }

  li:last-child {
    border-radius: 0 0 10px 0px;
  }
`;

const DropdownItem = styled.li`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  cursor: pointer;
  padding: 0.25rem;

  &:hover {
    background: rgb(0, 214, 136);
  }

  ${Dropdown}:hover & {
    transform: scale(1);
  }

  span {
    text-align: center;
    color: black;
  }
`;

const Text = styled.span`
  color: #6b6b6b;
  width: 100%;
  display: inline-block;
  white-space: pre;
  box-sizing: border-box;
`;

export type Item = {
  label: string;
  icon: string;
  onClick: () => void;
};

type SelectDownloadProps = {
  items: Item[];
};

const SelectDownload: React.FC<SelectDownloadProps> = ({ items }) => {
  const [open, setOpen] = useState<boolean>(false);
  const ref = React.useRef<HTMLDivElement>(null);

  useOutsideClick(ref, () => {
    setOpen(false);
  });

  return (
    <Wrapper
      ref={ref}
      onClick={(e) => {
        e.stopPropagation();
        setOpen(!open);
      }}
      className={open && 'dropdown-select-active'}
    >
      <Content>
        <Button size="small">Fazer download</Button>
        <Dropdown align="right" className={open && 'active'}>
          {items?.map((item, key) => {
            return (
              <DropdownItem key={key} onClick={item.onClick}>
                <Text>{item.label}</Text>
              </DropdownItem>
            );
          })}
        </Dropdown>
      </Content>
    </Wrapper>
  );
};

type Props = {
  isOpen: boolean;
  isLoading: boolean;
};

const InvitesFeedbackModal: React.FC<Props> = observer(({ isOpen, isLoading }) => {
  const vm = useViewModel(CreateInvitationViewModel);

  if (!isOpen) {
    return null;
  }

  if (isLoading) {
    return (
      <MyModal>
        <Container>
          <Loading />
        </Container>
      </MyModal>
    );
  }

  const options = [
    {
      label: '.csv',
      icon: 'invite',
      onClick: () => {
        exportObjectSheet(vm.invites, EFileExtension.CSV);
      },
    },
    {
      label: '.xlsx',
      icon: 'invite',
      onClick: () => {
        exportObjectSheet(vm.invites, EFileExtension.XLSX);
      },
    },
  ];

  return (
    <MyModal>
      <Container>
        <Title>Convites Gerados</Title>
        <Actions>
          <SelectDownload items={options} />
          <Button onClick={() => vm.setIsInvitesFeedbackOpen(false)} size="small">
            Concluir
          </Button>
        </Actions>
      </Container>
    </MyModal>
  );
});

export default InvitesFeedbackModal;
